import { Info, Lock } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~shared/shadcn/ui/tooltip';

export function SystemFooterPreview() {
  return (
    <div className="rounded-xl border border-[#FFE680] bg-[#FFFDF5] p-4">
      <div className="flex items-start gap-3">
        <Lock className="mt-0.5 size-5 text-gray-600" />
        <div className="flex-1 space-y-3">
          <div className="flex items-center gap-2">
            <h4 className="text-sm font-medium text-gray-700">
              System Footer (Auto-Appended)
            </h4>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <Info className="size-4 text-gray-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p className="max-w-xs text-sm">
                    This section is auto-generated and can&apos;t be edited.
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>

          {/* Footer Content Preview */}
          <div className="rounded-md border bg-white p-4 font-sans text-sm text-gray-700">
            <p className="mb-3">
              Your temporary password is{' '}
              <strong className="font-semibold text-[#000814]">
                {'{password}'}
              </strong>
            </p>
            <p>
              <a
                href="#"
                className="text-blue-600 underline"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                Login to the parent portal here
              </a>
            </p>
          </div>

          <p className="text-xs text-gray-600">
            This footer is automatically added to all onboarding emails and
            includes the temporary password and parent portal link.
          </p>
        </div>
      </div>
    </div>
  );
}

